export default __webpack_public_path__ + "static/media/logo_useradventure.bc93512c.jpg";